'use strict';

var React = require('react');

var SvgCashEuroMajor = function SvgCashEuroMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 10c0-5.514-4.486-10-10-10s-10 4.486-10 10 4.486 10 10 10 10-4.486 10-10zm-12.986.392a10.62 10.62 0 0 1 .014-1h-.278a.75.75 0 1 1 0-1.5h.49c.456-2.024 1.567-3.492 3.086-3.492 1.142 0 1.911.334 2.47 1.385a.992.992 0 0 1-1.75.932c-.16-.298-.24-.333-.72-.333-.335 0-.757.581-1.036 1.508h.959a.75.75 0 1 1 0 1.5h-1.231a8.247 8.247 0 0 0-.019 1h1.251a.75.75 0 1 1 0 1.5h-1.042c.272 1.102.749 1.812 1.119 1.812h.053c.329 0 .444.001.516-.054.04-.032.067-.081.11-.159a.993.993 0 0 1 1.738.958c-.555 1.006-1.205 1.24-2.366 1.239h-.051c-1.594 0-2.739-1.617-3.151-3.796h-.426a.75.75 0 1 1 0-1.5h.264z"
  }));
};

exports.SvgCashEuroMajor = SvgCashEuroMajor;
